<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center" @page:init="onPageInit()">
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.back()" class="custom-back">
          <i class="icon f7-icons" style="font-size: 22px;padding-left: 10px;">arrow_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("home_0094") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link popup-open=".huopopup" v-if="teamVipActiveBonusMainSetting.ShowActivityRule">
          <div  class="rule">{{ $t("luckbox_022") }}</div>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template>
      <div style="padding: 10px 10px 0 10px;background:var(--f7-THEME-color);">
        <div class="buttons-award" v-if="teamVipActiveBonusMainSetting">
          <f7-link tab-link="#tab-one"  :tab-link-active="teamVipActiveBonusMainSetting.DefaultTabIndex==0" :text="$t('award_0024')"></f7-link>
          <f7-link tab-link="#tab-two"  :tab-link-active="teamVipActiveBonusMainSetting.DefaultTabIndex==1" :text="$t('award_0025')"></f7-link>
          <f7-link tab-link="#tab-three" :tab-link-active="teamVipActiveBonusMainSetting.DefaultTabIndex==2" :text="$t('award_0026')"></f7-link>
        </div>
      </div>
      <f7-tabs >
        <f7-tab  id="tab-one"  :tab-active="teamVipActiveBonusMainSetting.DefaultTabIndex==0">
          <div class="content" v-if="DirectMemberVipBonusDetails.length>0" >
            <div class="time" v-if="teamVipActiveBonusMainSetting.ShowActivityCycle">
              <div>
                <div style="font-weight: bold;">{{ $t("award_0022") }}</div>
                <div class="xian">{{ teamVipActiveBonusMainSetting.StatisticsTimeFrom | time2 }} ~ {{ teamVipActiveBonusMainSetting.StatisticsTimeTo | time2}}</div>
              </div>
              <div>
                <div style="font-weight: bold;">{{ $t("award_0023") }}</div>
                <div style="color: #868686;">{{ teamVipActiveBonusMainSetting.ExchangeTimeFrom | time2}} ~ {{ teamVipActiveBonusMainSetting.ExchangeTimeTo | time2}}</div>
              </div>
            </div>

            <div class="title" >
              <span>{{ $t("award_0002") }}</span>
            </div>
            <div class="bigtitle" >
              {{ $t("award_0003") }}
            </div>
            <div >
              <div class="box" v-for="(item,index) in DirectMemberVipBonusDetails" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0004") }}<span style="color: #000;">&nbsp;({{ item.SubCurrActiveCount }}/{{ item.SubActiveCount }})</span></p>
                    <p v-if="item.SubCurrActiveCount>item.SubActiveCount"><f7-progressbar :progress="(item.SubActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.SubCurrActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.SubBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.SubBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.SubBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.SubStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,1)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="qidai">
            <div class="ablock">
              <img src="../../static/images/yt999/qidai.png" alt="" width="70%">
              <div>{{$t('bonusv1_04')}}</div>
            </div>
          </div>
        </f7-tab>
        <f7-tab  id="tab-two" :tab-active="teamVipActiveBonusMainSetting.DefaultTabIndex==1">
          <div class="content" v-if="TeamMemberVipBonusDetails.length>0">
            <!-- <div class="txt1" style="position: relative;">
              <span>{{ $t("award_0012") }}</span>
              <img src="../../static/images/yt999/awardImg.png"  alt="" srcset="" class="liwu"></div>
            <div class="txt2" >
              <span>{{ $t("award_0013") }}</span>
            </div> -->

            <div class="time" v-if="teamVipActiveBonusMainSetting.ShowActivityCycle">
              <div>
                <div style="font-weight: bold;">{{ $t("award_0022") }}</div>
                <div class="xian">{{ teamVipActiveBonusMainSetting.StatisticsTimeFrom | time2 }} ~ {{ teamVipActiveBonusMainSetting.StatisticsTimeTo | time2}}</div>
              </div>
              <div>
                <div style="font-weight: bold;">{{ $t("award_0023") }}</div>
                <div style="color: #868686;">{{ teamVipActiveBonusMainSetting.ExchangeTimeFrom | time2}} ~ {{ teamVipActiveBonusMainSetting.ExchangeTimeTo | time2}}</div>
              </div>
            </div>

            <div class="title" >
              <span>{{ $t("award_0008") }}</span>
            </div>
            <div class="bigtitle" >
              {{ $t("award_0009") }}
            </div>
            <div >
              <div class="box"   v-for="(item,index) in TeamMemberVipBonusDetails" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0010") }}<span style="color: #000;">&nbsp;({{ item.TeamCurrActiveCount }}/{{ item.TeamActiveCount }})</span></p>
                    <p v-if="item.TeamCurrActiveCount>item.TeamActiveCount"><f7-progressbar :progress="(item.TeamActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.TeamCurrActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.TeamBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.TeamBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.TeamBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.TeamStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,2)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="qidai">
            <div class="ablock">
              <img src="../../static/images/yt999/qidai.png" alt="" width="70%">
              <div>{{$t('bonusv1_04')}}</div>
            </div>
          </div>
        </f7-tab>
        <f7-tab  id="tab-three" :tab-active="teamVipActiveBonusMainSetting.DefaultTabIndex==2">
          <div class="content" v-if="Routing_SubordinateVipBonusDetailList.length>0">
            <div class="title" v-show="Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 2).length>0">
              <span>{{ $t("award_0002") }} ({{ $t("award_0027") }})</span>
            </div>
            <div v-show="Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 2).length>0">
              <div class="box" v-for="(item,index) in Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 2)" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0004") }}<span style="color: #000;">&nbsp;({{ item.SubCurrActiveCount }}/{{ item.SubActiveCount }})</span></p>
                    <p v-if="item.SubCurrActiveCount>item.SubActiveCount"><f7-progressbar :progress="(item.SubActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.SubCurrActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.SubBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.SubBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.SubBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.SubStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,1)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="title" v-show="Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 3).length>0">
              <span>{{ $t("award_0002") }} ({{ $t("award_0028") }})</span>
            </div>
            <div v-show="Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 3).length>0">
              <div class="box" v-for="(item,index) in Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 3)" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0004") }}<span style="color: #000;">&nbsp;({{ item.SubCurrActiveCount }}/{{ item.SubActiveCount }})</span></p>
                    <p v-if="item.SubCurrActiveCount>item.SubActiveCount"><f7-progressbar :progress="(item.SubActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.SubCurrActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.SubBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.SubBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.SubBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.SubStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,1)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="title" v-show="Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 4).length>0">
              <span>{{ $t("award_0002") }} ({{ $t("award_0029") }})</span>
            </div>
            <div v-show="Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 4).length>0">
              <div class="box" v-for="(item,index) in Routing_SubordinateVipBonusDetailList.filter(item => item.VipActiveBonusType === 4)" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0004") }}<span style="color: #000;">&nbsp;({{ item.SubCurrActiveCount }}/{{ item.SubActiveCount }})</span></p>
                    <p v-if="item.SubCurrActiveCount>item.SubActiveCount"><f7-progressbar :progress="(item.SubActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.SubCurrActiveCount/item.SubActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.SubBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.SubBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.SubBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.SubStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,1)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.SubStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="title" v-show="Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 5).length>0">
              <span>{{ $t("award_0008") }} ({{ $t("award_0027") }})</span>
            </div>
            <div v-show="Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 5).length>0">
              <div class="box" v-for="(item,index) in Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 5)" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0010") }}<span style="color: #000;">&nbsp;({{ item.TeamCurrActiveCount }}/{{ item.TeamActiveCount }})</span></p>
                    <p v-if="item.TeamCurrActiveCount>item.TeamActiveCount"><f7-progressbar :progress="(item.TeamActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.TeamCurrActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.TeamBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.TeamBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.TeamBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.TeamStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,2)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="title" v-show="Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 6).length>0">
              <span>{{ $t("award_0008") }} ({{ $t("award_0028") }})</span>
            </div>
            <div v-show="Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 6).length>0">
              <div class="box" v-for="(item,index) in Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 6)" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0010") }}<span style="color: #000;">&nbsp;({{ item.TeamCurrActiveCount }}/{{ item.TeamActiveCount }})</span></p>
                    <p v-if="item.TeamCurrActiveCount>item.TeamActiveCount"><f7-progressbar :progress="(item.TeamActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.TeamCurrActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.TeamBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.TeamBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.TeamBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.TeamStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,2)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="title" v-show="Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 7).length>0">
              <span>{{ $t("award_0008") }} ({{ $t("award_0029") }})</span>
            </div>
            <div v-show="Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 7).length>0">
              <div class="box" v-for="(item,index) in Routing_TeamVipBonusDetailList.filter(item => item.VipActiveBonusType === 7)" :key="index">
                <div class="box-header">
                  {{ item.ActionTitle?item.ActionTitle:'--' }}
                </div>
                <div class="box-body boxs">
                  <div class="info">
                    <p>{{ $t("award_0010") }}<span style="color: #000;">&nbsp;({{ item.TeamCurrActiveCount }}/{{ item.TeamActiveCount }})</span></p>
                    <p v-if="item.TeamCurrActiveCount>item.TeamActiveCount"><f7-progressbar :progress="(item.TeamActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>
                    <p v-else><f7-progressbar :progress="(item.TeamCurrActiveCount/item.TeamActiveCount)*100" style="width:100%;height:10px; border-radius: 5px;background: #e3e3e3;--f7-progressbar-progress-color: #feb600;"  /></p>

                    <div class="one" v-if="item.TeamBonus>0||item.BonusLuckyDrawChanceSettingList.length>0">
                      <span class="tit">{{ $t("award_0017") }}</span>
                      <p v-if="item.TeamBonus>0"><img  src="../../static/images/yt999/ico1.png"> <span>{{ $t("award_0020") }} ({{currencySymbol}} <span style="color: red;">{{ item.TeamBonus | formatCurrency2}}</span>)</span></p>
                      <div v-if="item.BonusLuckyDrawChanceSettingList.length>0">
                        <div v-for="(item2,index) in item.BonusLuckyDrawChanceSettingList" :key="index">
                          <p v-if="item2.Enable"><img  src="../../static/images/yt999/ico2.png"> {{ item2.ChannelID==1?$t("award_0014"):item2.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{item.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</p>
                        </div>
                      </div>
                    </div>

                    <div class="one" v-if="item.EnableVIPLevelLimit&&item.EnableVIPLevelNameList.length>0">
                      <span class="tit">{{ $t("award_0018") }}</span>
                      <span>
                        <span v-for="(item3,index) in item.EnableVIPLevelNameList" :key="index">{{ item3 }}、</span>
                      </span>
                    </div>

                    <div class="one" v-if="item.EnableReferrerLevelLimit&&item.ReferrerLevelLimitList.length>0">
                      <span class="tit">{{ $t("award_0019") }}</span>
                      <span>
                        <span v-for="(item4,index) in item.ReferrerLevelLimitList" :key="index">{{ item4 }}、</span>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button class="button" v-if="item.TeamStatus == 1">{{ $t("award_0005") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 2" style="background: green;" @click="reveiceAward(item.SubSettingID,item,2)">{{ $t("award_0006") }}</button>
                    <button class="button" v-else-if="item.TeamStatus == 3" style="background: #ccc;">{{ $t("award_0007") }}</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div v-else class="qidai">
            <div class="ablock">
              <img src="../../static/images/yt999/qidai.png" alt="" width="70%">
              <div>{{$t('bonusv1_04')}}</div>
            </div>
          </div>
        </f7-tab>
      </f7-tabs>
    </template>

    <van-popup v-model="vanshow"   class="vanshow">
      <div >
        <div>
          <img src="../../static/images/yt999/awardImg.png" height="100px">
        </div>
        <h4 class="da">{{$t("award_0011")}}</h4>
        <div v-if="bonusFlag==1">
          <h4  v-if="activeitem.SubBonus>0" class="xi">{{ $t("award_0020") }} <span style="color: red;">{{ currencySymbol }} {{activeitem.SubBonus | formatCurrency2}}</span></h4>
        </div>
        <div v-else-if="bonusFlag==2">
          <h4  v-if="activeitem.TeamBonus>0" class="xi">{{ $t("award_0020") }} <span style="color: red;">{{ currencySymbol }} {{activeitem.TeamBonus | formatCurrency2}}</span></h4>
        </div>
        <div v-if="activeitem.BonusLuckyDrawChanceSettingList.length>0">
          <div v-for="(item,index) in activeitem.BonusLuckyDrawChanceSettingList" :key="index">
            <h4  v-if="item.Enable" class="xi">{{ item.ChannelID==1?$t("award_0014"):item.ChannelID == 2?$t("award_0015"):$t("award_0016") }} (<span style="color: red;">+{{activeitem.BonusLuckyDrawChanceSettingList[index].BonusTimes}}</span>)</h4>
          </div>
        </div>
        <p class="yes" @click="vanshow=false">{{$t('common_0001')}}</p>
      </div>
    </van-popup>

    <f7-popup  class="huopopup" @popup:open="getwebsiteinfoGet" >
      <f7-page>
        <f7-navbar :title="$t('award_0021')" class="bg2">
          <f7-nav-right>
            <f7-link popup-close>
              <i class="f7-icons" style="color: #fff">multiply_circle</i>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div style="padding: 10px;" 
          v-html="websiteinfoGet.ReferrerSubordinateTeamVipActivityRulesRemark?websiteinfoGet.ReferrerSubordinateTeamVipActivityRulesRemark:'--'">
        </div>
      </f7-page>
    </f7-popup>

  </f7-page>
</template>

<script>
import { getStore } from "@/config/utils";
import { getAwardList, getAward, getwebsiteinfoGet, getTeamVipActiveBonusMainSetting  } from "../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      currencySymbol: getStore("currencySymbol"),
      TeamMemberVipBonusDetails: [],
      DirectMemberVipBonusDetails: [],
      Routing_SubordinateVipBonusDetailList: [],
      Routing_TeamVipBonusDetailList: [],
      vanshow: false,
      activeitem: {
        SubBonus:null,
        TeamBonus: null,
        BonusLuckyDrawChanceSettingList:[],
      },
      bonusFlag: 0,
      websiteinfoGet: {},
      teamVipActiveBonusMainSetting: {
        ShowActivityRule:null,
        DefaultTabIndex: 0
      },
      btnflag: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onPageInit(){
      this.getsAwardList();
      this.getTeamVipActiveBonusMainSetting();
    },
    getsAwardList(){
      getAwardList().then((data) => {
        if (data.Code === "NoError") {
          this.TeamMemberVipBonusDetails = data.Data.TeamMemberVipBonusDetails;
          this.DirectMemberVipBonusDetails = data.Data.DirectMemberVipBonusDetails;
          this.Routing_SubordinateVipBonusDetailList = data.Data.Routing_SubordinateVipBonusDetailList;
          this.Routing_TeamVipBonusDetailList = data.Data.Routing_TeamVipBonusDetailList;
        }
      });
    },

    reveiceAward(id,item,bonusFlag) {
      this.bonusFlag = bonusFlag;
      if(!this.btnflag){
        return;
      }
      this.btnflag = false;
      const params = { "SettingID": id };
      const d = { data: JSON.stringify(params) };
      this.activeitem = item;
      getAward(d).then((data) =>{
        this.btnflag = true;
        if (data.Code === "NoError") {
          this.vanshow = true;
          this.getsAwardList();
        }else{
          this.$f7.dialog.alert(data.Data, this.$t("common_0004"));
        }
      });
      
    },
    getwebsiteinfoGet(){
      getwebsiteinfoGet().then((data) => {
        if (data.Code === "NoError") {
          this.websiteinfoGet = data.Data;
        }
      });
    },

    getTeamVipActiveBonusMainSetting(){
      getTeamVipActiveBonusMainSetting().then((data) => {
        if (data.Code === "NoError") {
          this.teamVipActiveBonusMainSetting = data.Data;
        }
      });
    },

  },
  created() {

  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>
::v-deep .navbar-inner{    //头部颜色更换
  color: white;
  background: var(--f7-THEME-color);
  a{
    color: white;
  }
}

.buttons-award {
  background: #fff;
  border: 1px solid #fff;
  border-radius: 10px;
}
.buttons-award a.tab-link {
  color: #000;
  // min-height: 50px;
  padding:5px 22px;
  text-align: center;
  border-right: 1px solid var(--f7-THEME-color);
  :last-child {
    border-right: none;
    line-height: 15px;
  }
}
.buttons-award a.tab-link:last-child {
    border-right: none;
    
  }
.buttons-award a.tab-link.tab-link-active {
  color: var(--f7-THEME-color);
}
.buttons-award a.tab-link:last-child:after {
  width: 0;
  height: 0;
  display: none;
}
.buttons-award {
  width: var(--f7-width-size-pt100);
  display: var(--f7-display-flex);
  justify-content: var(--f7-text-center);
  box-sizing: var(--f7-border-box);
  align-items: var(--f7-text-center);
  align-content: var(--f7-text-center);
  overflow: var(--f7-hidden);
  //background-color: #0C1939;

  a.tab-link {
    width: var(--f7-width-size-pt100);
    height: var(--f7-height-size-pt100);
    box-sizing: var(--f7-border-box);
    display: var(--f7-display-flex);
    justify-content: var(--f7-text-center);
    align-items: var(--f7-text-center);
    flex-direction: var(--f7-flex-direction);
    text-transform: var(--f7-tabbar-link-text-transform);
    font-weight: var(--f7-tabbar-link-font-weight);
    letter-spacing: var(--f7-tabbar-link-letter-spacing);
    overflow: var(--f7-hidden);
    i {
      margin-top: var(--f7-padding-size-2);
      font-size: var(--f7-px-32);
    }

    span {
      font-size: var(--f7-px-14);
      margin-left: var(--f7-margin-size-0);
    }
  }

  a.tab-link:after {
    content: "";
    //background: url(../static/images/yt999/navafter.png) no-repeat;
    width: var(--f7-width-size-2);
    height: var(--f7-height-size-pt100);
    position: absolute;
    right: var(--f7-size-ps-0);
    top: var(--f7-size-ps-0);
    background-size: var(--f7-size-percent-100) var(--f7-size-percent-100);
  }

  a.tab-link:last-child:after {
    height: var(--f7-height-size-0);
  }

  a.tab-link.tab-link-active {
    // border-bottom: 1px solid var(--f7-common-border-color);

    i.iconfont {
      color: var(--f7-color-blue-active);
    }
  }
}



.content {
  padding: 10px;
  background: linear-gradient(1.98deg, var(--f7-THEME-color2) 3.12%, var(--f7-THEME-color) 95.71%);
  min-height: 98%;
  .txt1{
    padding-left: 6px;
    color: white;
    font-size: 28px;
    font-weight: bold;
    .liwu{
      height: 82px;
      position: absolute;
      right: 70px;
      bottom: -34px;
    }
  }
  .txt2{
    width: 58%;
    padding-left: 6px;
    color: white;
    font-size: 18px;
    font-weight: bold;

  }
  .time{
    padding: 10px;
    background: white;
    border-radius: 10px;
    .xian{
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 6px;
      margin-bottom: 6px;
      color: #868686;
    }
  }
  .title{
    position: relative;
    font-size: 16;
    font-weight: bold;
    margin: 10px 0px;
    padding-left: 10px;
    color: white;


  }
  .title::after{
    content: '';
    position: absolute;
    top: 4px;
    left: 0px;
    transform: translateX(-50%);
    width: 3px;
    height: 60%;
    background-color: #feb600;
  }
  .bigtitle{
    background: linear-gradient(to bottom, #71c9e7, #fff);
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 10px;
    font-weight: bold;
  }
  .box{
    background: #fff;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 10px;
    .box-header{
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 7px;
      font-weight: bold;
      word-break: break-word;
      white-space: normal;
    }
    .box-body{
      .icon{
        span{
          display: inline-block;
          height: 50px;
          line-height: 38px;
          text-align: center;
          color: red;
          font-weight: bold;
          background: url(../../static/images/yt999/awardRed.png);
          background-size: 100% 100%;
          width: 100%;
          // padding: 0px 4px;
          font-size: 12px;
        }
      }
      .info{
        p{
          margin: 0px;
          font-size: 12px;
          margin: 5px 0;
          display: flex;
          img{
            height: 16px;
            margin-right: 5px;
          }
          
        }
        p:nth-child(1){
          font-size: 12px;
        }
        .one{
          border: 1px solid #ffe8e8;
          padding: 5px;
          border-radius: 5px;
          padding-top: 30px;
          position: relative;
          margin-top: 10px;
          .tit{
            font-weight: bold;
            background: var(--f7-THEME-color2);
            padding: 5px 20px 5px 7px;
            font-size: 12px;
            border-radius: 5px 0px 40px 0px;
            position: absolute;
            top: 0;
            left: 0;
          }
          span{
            font-size: 12px;
            display: inline-block;
          }
        }
      }
      .button{
        line-height: 35px;
        height: 35px;
        border-radius: 18px;
        margin-top: 10px;
        text-transform: none;
        white-space: normal;
      }

    }
    .boxs{
      padding-bottom: 10px;
      border-bottom: 2px solid #e7e7e7;
    }
    .boxs:last-child{
      border: none;
    }
  }
}
::v-deep .page-content::after{
  height: 0;
}
.vanshow{
  text-align: center;
  width: 300px;
  border-radius: 10px;
  overflow: visible;
  padding: 20px 0 ;
  .da{
    margin:5px 0;
    font-size: 16px;
    padding: 0 10px;
  }
  .xi{
    margin: 0;
    font-weight: 100;
  }
  .yes{
    margin-bottom: 20px;
    background: var(--f7-THEME-color);
    color: white;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    padding: 0 60px;
    border-radius: 10px;
    margin-bottom: 0;
  }
}

.ruledialog {
  width: 86%;
  margin: 0 7%;
  background-color: white !important;
  left: 0;

  .dialog-inner {
    padding: 0;
    text-align: left;

    .dialog-title {
      text-align: center;
      position: relative;
      font-size: 18px;
      padding-bottom: 4px;
      height: 35px;
      line-height: 35px;
      h3 {
        margin: 0 0 2px 0;
      }

      h5 {
        margin: 0;
        font-weight: normal;
      }
    }

    .dialog-title:after {
      content: "";
      position: absolute;
      z-index: 1;
      background: url(../../static/images/yt999/light.png) no-repeat;
      background-size: var(--f7-size-percent-100) var(--f7-size-percent-100);
      height: var(--f7-height-size-2);
      width: 100%;
      display: block;
      top: auto;
      right: auto;
      bottom: 0;
      left: 0;
      transform-origin: 50% 100%;
      transform: scaleY(1);
      transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    }

    .dialog-text {
      .block-message {
        margin: var(--f7-margin-size-0);
        padding: var(--f7-padding-size-0);
        width: var(--f7-width-size-pt100);

        .block-content {
          padding: var(--f7-padding-size-8) var(--f7-padding-size-10);
          height: 300px;
          overflow: hidden scroll;
          background:white;
          height: 350px
        }

        .row-toggle {
          margin: 10px 10px 0;

          span {
            color: var(--f7-dialog-button-text-color-right);
          }

          .toggle {
            margin-top: var(--f7-margin-size-f2);
          }
        }

        .block-footer {
          margin-top: 8px;

          .row.no-gap {
            --f7-grid-gap: 0px;
          }

          .button {
            height: 50px;
            line-height: 50px;
            color: var(--f7-color-white);
            font-size: var(--f7-px-16);
          }

          .btn-next {
            background: var(--f7-dialog-button-bg-color-right);
            color: var(--f7-dialog-button-text-color-right);
          }

          .btn-next.button-disabled {
            opacity: 0.6;
            // color: var(--f7-dialog-button-text-disable-color-right) !important;
          }

          .btn-close {
            background-color: var(--f7-dialog-button-bg-color-left);
            color: var(--f7-dialog-button-text-color-left);
            border-radius: 0;
          }
        }
      }
    }
  }
}
.rule {
  color: black;
  background: var(--f7-THEME-color2);
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 25px;
  padding: 0 12px;
  font-size: 14px;
  margin-right: 10px;
}
.qidai{
  background: var(--f7-THEME-color);
  text-align: center;
  padding: 10px;
  height: 100vh;
  div{
    font-size: 18px;
  }
  .ablock{
    background: #fff;
    min-height: 80vh;
    border-radius: 10px;
    padding-top: 50px;
  }
}
</style>